// import { ArticleTypeType } from 't2-graphql-types';
import { TPermissions } from 't2-keystone/src/schema/Permission/permissions';
import { THasPermission } from '../../Permissions/hooks/useHasPermission';

// TODO: l:1 doesn't work fine
enum ArticleTypeType {
  Article = 'ARTICLE',
  Prompt = 'PROMPT',
  Quote = 'QUOTE',
}

export const hasPermissionToCreateArticleOnTerritory = (
  hasPermission: THasPermission,
  articleType: ArticleTypeType,
  territoryId?: string,
): boolean => {
  const territoryCreatePermission: TPermissions =
    articleType === ArticleTypeType.Prompt ? 'TERRITORY_CAN_CREATE_PROMPT' : 'TERRITORY_CAN_CREATE_POST';
  const canCreateArticle =
    hasPermission('GLOBAL_CAN_CREATE_ARTICLE') ||
    (!!territoryId && hasPermission(territoryCreatePermission, territoryId));
  const canManageArticleTerritory =
    hasPermission('GLOBAL_CAN_MANAGE_ARTICLE_TERRITORY') ||
    hasPermission('GLOBAL_CAN_MANAGE_OWN_ARTICLE_TERRITORY') ||
    (!!territoryId &&
      (hasPermission('TERRITORY_CAN_MANAGE_ARTICLE_TERRITORY', territoryId) ||
        hasPermission('TERRITORY_CAN_MANAGE_OWN_ARTICLE_TERRITORY', territoryId)));

  return canCreateArticle && canManageArticleTerritory;
};
